import * as Yup from 'yup';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import { difficulties } from '../../utils/constants';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const DifficultyLevel = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const difficultiesOptions = createLocalizedOptions(difficulties, messages);

  useEffect(() => {
    const difficultyLevelSchema = {
      difficultyId: Yup.number()
        .typeError(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
        .required(intl.formatMessage({ ...siteMessages.FIELD_REQUIRED }))
    };
    updateSchema(difficultyLevelSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="difficultyId"
      label={intl.formatMessage({ ...messages.difficulties })}
      isMulti={false}
      options={difficultiesOptions}
      value={values.difficultyId}
      error={errors.difficultyId}
      setFieldValue={setFieldValue}
    />
  );
};

export default DifficultyLevel;
